import { Box } from "@mui/material";
import { Aish5XLogo } from "../../../components/branding/Aish5XLogo";

export default function BrandLogoSection() {
  return (
    <section className="w-full py-16 bg-white">
      <Box className="max-w-4xl mx-auto flex justify-center">
        <Aish5XLogo height={126} />
      </Box>
    </section>
  );
}